export const THEME_STORAGE_KEY = "C2MDTHEME";

export const DEFAULT_THEME = {
  PRIMARY_COLOR: "#801749",
  SECONDARY_COLOR: "#FFFFFF",
};

export const themeUtils = {
  getPrimaryColor: () => {
    return localStorage.getItem(THEME_STORAGE_KEY)
      ? JSON.parse(localStorage.getItem(THEME_STORAGE_KEY)).PRIMARY_COLOR
      : DEFAULT_THEME.PRIMARY_COLOR;
  },
  getSecondaryColor: () => {
    return localStorage.getItem(THEME_STORAGE_KEY)
      ? JSON.parse(localStorage.getItem(THEME_STORAGE_KEY)).SECONDARY_COLOR
      : DEFAULT_THEME.SECONDARY_COLOR;
  },
};
